export const ROUTE_NAME_TYPE_MAP = {
  'garbage': 'garbage_source',
  'msn': 'msn',
  'registry.operators': 'tko_operator',
  'registry.regionalOperators': 'tko_operator',
  'registry': 'tko_object',
  'access.threads': 'thread',
  'unauthorized.heaps': 'unauthorized_heap'
}